import {POST, GET} from '../services/api'
import {getPlugintypeIdByCode} from '../functions/plugintype'
import useAuth from '../hooks/useAuth'

type IntegrationType = {
  id: number
  name: string
  type: string
  templateType: string
  typeId: number
  idintegration: number
}

type IntegrationResponseType = {
  id: number
  name: string
  plugintemplateId: {
    id: number
    name: string
    parameters: string
    plugintypeId: number
    typeIntegration: string
  }
}

const getIntegrations = async (
  loginInfo: {plugintype: string},
  take: number = 10,
  page: number = 1
) => {
  try {
    const integrationRes = await POST(`/pluginconfig/filter`, {})
    const newIntegrations: IntegrationType[] = integrationRes.data.map(
      (pluginconfig: IntegrationResponseType) => {
        return {
          id: pluginconfig.id,
          name: pluginconfig.name,
          type: pluginconfig.plugintemplateId.name,
          typeId: pluginconfig.plugintemplateId.plugintypeId,
          templateType: pluginconfig.plugintemplateId.typeIntegration,
          idintegration: pluginconfig.plugintemplateId.id,
        }
      }
    )

    const plugincode = getPlugintypeIdByCode(loginInfo.plugintype)

    const integrationsGet: IntegrationType[] = newIntegrations.filter(
      (integration) =>
        integration.templateType === 'others' &&
        (integration.typeId === plugincode || integration.typeId === 1)
    )

    const detailedIntegrations = await Promise.all(
      integrationsGet
        .filter(
          (integration) => integration.idintegration === 65 || integration.idintegration === 201
        )
        .map((integration) => GET(`/pluginconfig/${integration.id}`))
    )

    return detailedIntegrations // Retorna os detalhes das integrações filtradas
  } catch (e) {
    return Promise.reject(e)
  }
}

export default getIntegrations
